import script from "./Particles.vue?vue&type=script&setup=true&lang=js"
export * from "./Particles.vue?vue&type=script&setup=true&lang=js"

import "./Particles.vue?vue&type=style&index=0&id=66f1fa9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f1fa9a"]])

export default __exports__